import toNumber from './toNumber';

export default function toCurrency(value) {
  return `$${toNumber(value)}`;
};
